const toHex = (buffer: ArrayBuffer): string =>
  [...new Uint8Array(buffer)]
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')

const sha256 = async (input: string): Promise<string> => {
  const encoded = new TextEncoder().encode(input)
  const digest = await crypto.subtle.digest('SHA-256', encoded)
  return toHex(digest)
}

export { sha256 }
